import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["for", "innerHTML"]
const _hoisted_3 = {
  key: 2,
  class: "tn-textarea__description"
}
const _hoisted_4 = {
  key: 3,
  class: "tn-textarea__description"
}
const _hoisted_5 = {
  key: 4,
  class: "tn-textarea__error"
}
const _hoisted_6 = {
  key: 5,
  class: "tn-textarea__warn"
}
const _hoisted_7 = {
  key: 6,
  class: "tn-textarea__success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaAutosize = _resolveComponent("TextareaAutosize")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tn-textarea", {
      'tn-textarea_required': _ctx.required,
      'tn-textarea_error': !!_ctx.error,
      'tn-textarea_success': !!_ctx.success,
      'tn-textarea_warn': !!_ctx.warn
    }])
  }, [
    _renderSlot(_ctx.$slots, "header"),
    (_ctx.hasLabelSlot)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "tn-textarea__label",
          for: _ctx.inputId
        }, [
          _renderSlot(_ctx.$slots, "label")
        ], 8, _hoisted_1))
      : (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            class: "tn-textarea__label",
            for: _ctx.inputId,
            innerHTML: _ctx.label
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
    (_ctx.hasDescriptionSlot)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _renderSlot(_ctx.$slots, "description")
        ]))
      : (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true),
    _createVNode(_component_TextareaAutosize, {
      id: _ctx.inputId,
      ref: "textarea",
      class: _normalizeClass(["tn-textarea__textarea", {
        'tn-textarea__textarea_disabled': _ctx.isTextareaDisabled,
        'tn-textarea__textarea_error': !!_ctx.error,
        'tn-textarea__textarea_success': !!_ctx.success,
        'tn-textarea__textarea_warn': !!_ctx.warn,
        [_ctx.textareaClass || '']: !!_ctx.textareaClass
      }]),
      "max-height": _ctx.maxHeight,
      placeholder: _ctx.placeholder,
      readonly: _ctx.isTextareaDisabled,
      disabled: _ctx.isTextareaDisabled,
      "min-height": _ctx.minHeight,
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.emitInput
    }, null, 8, ["id", "max-height", "placeholder", "readonly", "disabled", "min-height", "class", "model-value", "onUpdate:modelValue"]),
    (_ctx.error && _ctx.error.trim())
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.warn && _ctx.warn.trim())
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.warn), 1))
      : _createCommentVNode("", true),
    (_ctx.success && _ctx.success.trim())
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.success), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "footer")
  ], 2))
}